<div class="p-grid flex flex-column h-100" *ngIf="!displayMultiCommentDialog && !displayMultiPlateComment">
  <div class="p-col flex-1 overflow-y-auto p-2" *ngIf="!isLoading && comments.length === 0">
    No comments! Start by adding one...
  </div>
  <div class="p-col flex-1 overflow-y-auto p-2" *ngIf="isLoading">
    <div class="card p-1 mb-3">
      <div class="p-2">
        <p-skeleton width="5rem" styleClass="p-1 mb-2"></p-skeleton>
        <p-skeleton width="10rem" styleClass="p-1 mb-2"></p-skeleton>
      </div>
    </div>
    <div class="card p-1 mb-3">
      <div class="p-2">
        <p-skeleton width="5rem" styleClass="p-1 mb-2"></p-skeleton>
        <p-skeleton width="10rem" styleClass="p-1 mb-2"></p-skeleton>
      </div>
    </div>
  </div>
  <div class="p-col flex-1 overflow-y-auto p-2" *ngIf="!isLoading && comments.length !== 0"
    style="flex-grow: 1; overflow-y: auto;">
    <div class="mb-2 p-2 border-1 border-primary border-round-xl" *ngFor="let comment of comments.reverse()">
      <div class="flex justify-content-between align-items-center mb-2">
        <div class="p-1 p-col font-bold">
          {{comment.plateId || comment.runId }} | {{ comment.puid }} | {{ comment.timeStamp | date: 'dd.MM.yy HH:mm' }} | {{ comment.status }}
        </div>
      </div>
      <div class="pt-2 pl-1 p-col">{{ comment.comment }}</div>
    </div>
  </div>
  <div class="p-col-12 p-1 mt-4 flex justify-content-end align-items-center p-3">
    <textarea [(ngModel)]="newComment" placeholder="Add a comment..." rows="2"
      class="p-inputtext p-1 mr-2 border-1 border-primary border-round-xl p-2 flex-1" style="resize: none;"></textarea>
    <button pTooltip="Add comment" type="button" (click)="postComment()" [disabled]="newComment === ''"
      class="p-button p-button-raised p-button-primary">
      <i class="fa-regular fa-message p-1 text-0"></i>
    </button>
  </div>
</div>

<div class="p-grid flex flex-column h-100" *ngIf="displayMultiCommentDialog && !displayMultiPlateComment">
  <div class="p-col-12 p-1 mt-4 flex justify-content-end align-items-center p-3">
    <textarea [(ngModel)]="newComment" placeholder="Add a comment..." rows="2"
      class="p-inputtext p-1 mr-2 border-1 border-primary border-round-xl p-2 flex-1" style="resize: none;"></textarea>
    <button pTooltip="Add comment" type="button" (click)="postComment()" [disabled]="newComment === ''"
      class="p-button p-button-raised p-button-primary">
      <i class="fa-regular fa-message p-1 text-0"></i>
    </button>
  </div>
</div>

<!-- only shown to show multi plate specific comments in extraction and arrays processing flow  -->
<div class="p-grid flex flex-column h-100" *ngIf="displayMultiPlateComment">
  <div class="p-col flex-1 overflow-y-auto p-2" *ngIf="!isLoading && comments.length === 0">
    No comments! Start by adding one...
  </div>
  <div class="p-col flex-1 overflow-y-auto p-2" *ngIf="isLoading">
    <div class="card p-1 mb-3">
      <div class="p-2">
        <p-skeleton width="5rem" styleClass="p-1 mb-2"></p-skeleton>
        <p-skeleton width="10rem" styleClass="p-1 mb-2"></p-skeleton>
      </div>
    </div>
    <div class="card p-1 mb-3">
      <div class="p-2">
        <p-skeleton width="5rem" styleClass="p-1 mb-2"></p-skeleton>
        <p-skeleton width="10rem" styleClass="p-1 mb-2"></p-skeleton>
      </div>
    </div>
  </div>
  <div class="p-col flex-1 overflow-y-auto p-2" *ngIf="!isLoading && comments.length !== 0"
    style="flex-grow: 1; overflow-y: auto;">
    <div class="mb-2 p-2 border-1 border-primary border-round-xl" *ngFor="let comment of comments.reverse()">
      <div class="flex justify-content-between align-items-center mb-2">
        <div class="p-1 p-col font-bold">
          {{comment.plateId}} | {{ comment.puid }} | {{ comment.timeStamp | date: 'dd.MM.yy HH:mm' }} | {{ comment.status }}
        </div>
      </div>
      <div class="pt-2 pl-1 p-col">{{ comment.comment }}</div>
    </div>
  </div>
  <div class="p-col-12 p-1 mt-4 flex justify-content-end align-items-center p-3">
    <p-multiSelect   [(ngModel)]="selectedPlates" class="h-3rem w-5 inline-flex" (onChange)="onPlateSelect($event)"
    appendTo="body" placeholder="Select Plates to Update" [options]="plateOptions" [showClear]="true" name="sampleList"></p-multiSelect>
    <textarea [(ngModel)]="newComment" placeholder="Add a comment..." rows="2"
      class="p-inputtext p-1 mr-2 border-1 border-primary border-round-xl p-2 flex-1" style="resize: none;"></textarea>
    <button pTooltip="Add comment" type="button" (click)="postComment()" [disabled]="newComment === ''"
      class="p-button p-button-raised p-button-primary">
      <i class="fa-regular fa-message p-1 text-0"></i>
    </button>
  </div>
</div>

